import React from "react";
import { ValidatedInviteCodeDto } from "@growth-machine-llc/stridist-api-client";
import { BoxProps, Dialog, IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ClientDetailedLinkInviteScreenContent } from "./ClientDetailedLinkInviteScreenContent";
import { Close } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  close: {
    position: "absolute",
    top: theme.spacing(3),
    right: theme.spacing(3),
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(-1.5),
    marginRight: theme.spacing(-1.5),

    "&:hover": {
      color: theme.palette.text.primary,
    },
  },
}));

export interface LoggedOutClientDetailedLinkInviteScreenProps extends BoxProps {
  invite: ValidatedInviteCodeDto;
  enabled?: boolean;
  children?: React.ReactNode;
}

export function LoggedOutClientDetailedLinkInviteScreen(
  props: LoggedOutClientDetailedLinkInviteScreenProps,
) {
  const { invite, enabled, children, ...other } = props;
  const s = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => setOpen(true), []);
  const handleClose = React.useCallback(() => setOpen(false), []);

  return enabled ? (
    <>
      <ClientDetailedLinkInviteScreenContent
        invite={invite}
        onButtonClick={handleOpen}
        {...other}
      />
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <IconButton
          className={s.close}
          color="primary"
          onClick={handleClose}
          children={<Close />}
          size="large"
        />
        {children}
      </Dialog>
    </>
  ) : (
    <>{children}</>
  );
}
